export function unixFromDateTime(dateStr: string | Date): number {
  return Math.floor(new Date(dateStr).getTime() / 1000);
}
